import { Link } from "react-router-dom";

const CustomLink = ({
  href,
  to,
  className,
  children,
  ...props
}: {
  href: string;
  to?: string;
  className?: string;
  children: React.ReactNode;
  [key: string]: any;
}) => {
  return (
    <Link to={to || href} className={className} {...props}>
      {children}
    </Link>
  );
};

export default CustomLink;